// ConfirmSubscription.jsx
import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { publicAxios } from "../../../config/apiConfig";

export default function ConfirmSubscription() {
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");
    const [status, setStatus] = useState("loading");
    const navigate = useNavigate();

    useEffect(() => {
        if (!token) { setStatus("invalid"); return; }
        const confirm = async () => {
            try {
                await publicAxios.get(`confirm?token=${encodeURIComponent(token)}`, {
                    headers: { "X-Frontend-Base-Url": window.location.origin }
                });
                setStatus("ok");
            } catch (err) {
                setStatus("error");
            }
        };
        confirm();
    }, [token]);

    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-50 px-4">
            <div className="w-full max-w-md bg-white rounded-2xl shadow-lg flex flex-col justify-between p-6">
                {/* Content */}
                {status === "ok" && (
                    <div className="flex flex-col items-center text-center flex-grow">
                        <h2 className="text-2xl font-bold mb-4 text-gray-900">
                            Subscription confirmed
                        </h2>
                        <p className="text-gray-600 leading-relaxed">
                            We sent a management link to your email. Use that link to manage your
                            preferences or unsubscribe anytime.
                        </p>
                    </div>
                )}
                {status === "invalid" && (
                    <div className="flex flex-col items-center text-center flex-grow">
                        <h2 className="text-2xl font-bold mb-4 text-gray-900">
                            Invalid link.
                        </h2>
                        <p className="text-gray-600 leading-relaxed">
                            Please, try again.
                        </p>
                    </div>
                )}
                {status === "error" && (
                    <div className="flex flex-col items-center text-center flex-grow">
                        <h2 className="text-2xl font-bold mb-4 text-gray-900">
                            Invalid or expired confirmation token.
                        </h2>
                        <p className="text-gray-600 leading-relaxed">
                            Please, try again.
                        </p>
                    </div>
                )}
                {status === "loading" && (
                    <div className="flex flex-col items-center text-center flex-grow">
                        <h2 className="text-2xl font-bold mb-4 text-gray-900">
                            Loading.....
                        </h2>
                        <p className="text-gray-600 leading-relaxed">
                            Please wait some movement...
                        </p>
                    </div>
                )}

                {/* Footer / Button */}
                <div className="mt-8">
                    <button
                        className="w-full px-4 py-3 bg-blue-600 text-white font-semibold rounded-lg shadow hover:bg-blue-700 transition"
                        onClick={() => navigate("/")}
                    >
                        Go home
                    </button>
                </div>
            </div>
        </div>

    );
}
